// extracted by mini-css-extract-plugin
module.exports = {"title":"SideMenu_title__1BkD-","sideMenuFooter":"SideMenu_sideMenuFooter__10M7Q"};